/**
 * Carried over verbatim from the old Resume.cshtml. `highlight` marks the roles shown in the
 * condensed timeline on the home page; the resumé page shows every entry with its bullets.
 */
export type Role = {
  title: string;
  employer: string;
  location: string;
  period: string;
  bullets: string[];
  highlight?: boolean;
};

export const roles: Role[] = [
  {
    title: 'Nanny',
    employer: 'Client Family Household',
    location: 'Atlanta, GA',
    period: 'Jul 2022 – Aug 2023',
    highlight: true,
    bullets: [
      'Was responsible for feedings, changing diapers and establishing a daily routine including socialization and recreation',
      'Worked with a set of infant twins until they were ready to start preschool',
      'Helped family with light housekeeping',
    ],
  },
  {
    title: 'Nanny',
    employer: 'Client Family Household',
    location: 'Smyrna, GA',
    period: 'Aug 2021 – Jun 2022',
    highlight: true,
    bullets: [
      'Worked daily with an infant until they were ready to start preschool',
      'Helped with daily routines and infant care',
      'Helped to keep the infant’s laundry and dishes clean',
    ],
  },
  {
    title: 'Lead Teacher',
    employer: 'Primrose School',
    location: 'Atlanta, GA',
    period: '2018 – 2019',
    highlight: true,
    bullets: [
      'Implement a curriculum and engage in activities with the children',
      'Develop strong, lasting relationships with parents and children',
      'Working with age groups between infancy to five years of age',
    ],
  },
  {
    title: 'Teacher',
    employer: "Kids R' Kids",
    location: 'Atlanta, GA',
    period: '2014 – 2018',
    highlight: true,
    bullets: [
      'Rendered extensive child care such as changing diapers, feeding children, putting children down for naps, and educational interactions',
      'Worked with age groups between infancy to five years of age',
      'Occasionally assisted with summer camp program including field trips and swimming supervision',
    ],
  },
  {
    title: 'Nanny',
    employer: 'Client Family Household',
    location: 'Atlanta, GA',
    period: '2011 – 2012',
    bullets: [
      'Worked daily (M-F) with an infant from one month to one year of age',
      'Helped family with light housekeeping and maintenance',
    ],
  },
  {
    title: 'Teacher – Float',
    employer: 'Oxford Academy',
    location: 'Atlanta, GA',
    period: '2010 – 2011',
    bullets: [
      'Assisted lead teachers with various tasks including clean-up, child care and child education',
      'Worked with age groups between infancy to five years of age',
    ],
  },
];

export const education = {
  school: 'Chattahoochee Tech',
  location: 'Atlanta, GA',
  period: '2011 – 2012',
  detail: 'Working towards Diploma in Early Childhood Education and Development',
};

export const additionalSkills: string[] = [
  'CPR/First Aid Certified',
  'Fire Safety Certified',
  'Experienced with Microsoft Office Word and PowerPoint',
  '41 WPM typing speed with 88% accuracy',
];
